function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.15v3.75c0 .35-.07.69-.21 1.01s-.34.61-.6.84c-.26.24-.56.41-.89.53s-.68.15-1.03.12c-3.85-.42-7.54-1.73-10.79-3.84a24.398 24.398 0 0 1-7.5-7.5A24.747 24.747 0 0 1 2.64 5.22c-.03-.35 0-.69.12-1.02.11-.33.29-.63.52-.89.23-.26.52-.46.84-.6.32-.14.66-.21 1.01-.21h3.75c.61 0 1.19.21 1.65.6.46.4.76.94.85 1.55.16 1.2.45 2.38.88 3.51.17.45.2.93.1 1.4-.1.47-.33.9-.67 1.24l-1.59 1.59a20 20 0 0 0 7.5 7.5l1.59-1.59c.34-.34.77-.57 1.24-.67.47-.1.95-.06 1.4.1 1.13.42 2.31.72 3.51.88.61.09 1.16.39 1.56.86.4.47.61 1.07.59 1.68Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
};

export default SvgContact;